import firebase from 'firebase';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCpR2-_4Looy7ov_HDjFJ4tW88cOgn559A",
  authDomain: "tinder-clone-9de69.firebaseapp.com",
  projectId: "tinder-clone-9de69",
  storageBucket: "tinder-clone-9de69.appspot.com",
  messagingSenderId: "506909982444",
  appId: "1:506909982444:web:68f30e3ffe4b96365cafc9",
  measurementId: "G-0Y4Y2QJBYE"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const database = firebaseApp.firestore();

export default database;